import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-25193f48"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h-full px-2 pt-2 text-left border-r border-gray-300" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-2xl font-semibold" }, "Distribution over time", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mx-2 my-2 h-8 node-color-gradient" }, null, -1))
const _hoisted_5 = { class: "px-2 text-sm inline-block w-full" }
const _hoisted_6 = { class: "float-left" }
const _hoisted_7 = { class: "float-right" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "text-2xl font-semibold" }
const _hoisted_10 = { class: "w-1/2 mx-auto" }

import ClusterList from '@/components/Search/LeftPane/ClusterList.vue';
import Doughnut from '@/components/Search/LeftPane/Doughnut.vue';
import {
  AnalysisType,
  AuthorAnalysisType,
  Community,
  PublicationAnalysisType,
} from '@/models/Search';
import { computed, PropType } from 'vue';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  props: {
  oldestYear: Number,
  newestYear: Number,
  clusters: {
    type: Object as PropType<Community[]>,
    required: true,
  },
  clusterColors: {
    type: Object as PropType<Record<number, string>>,
    required: true,
  },
  currentAnalysis: {
    type: String as PropType<AnalysisType>,
    required: true,
  },
},
  setup(__props) {

const props = __props



const store = useStore();

const title = computed(() => {
  switch (props.currentAnalysis) {
    case PublicationAnalysisType.HYBRIDFRONTS || PublicationAnalysisType.RESEARCHFRONTS:
      return 'Trending topics';
    case PublicationAnalysisType.KNOWLEDGEBASES:
      return 'Knowledge bases';
    case AuthorAnalysisType.COAUTHORNETWORK:
      return 'Author communities';
    default:
      return '';
  }
});

const addSelectedClusterId = async (clusterId: number) => {
  await store.dispatch('clusterControls/add', clusterId);
};

const deleteSelectedClusterId = async (clusterId: number) => {
  await store.dispatch('clusterControls/delete', clusterId);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.oldestYear && __props.newestYear)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(__props.oldestYear), 1),
            _createElementVNode("span", _hoisted_7, _toDisplayString(__props.newestYear), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (__props.clusters && __props.clusters.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(title) + ': ' + (__props.clusters.length - 1)), 1),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(Doughnut, {
              onHover: _cache[0] || (_cache[0] = (clusterId) => addSelectedClusterId(clusterId)),
              onMouseleave: _cache[1] || (_cache[1] = (clusterId) => deleteSelectedClusterId(clusterId))
            })
          ]),
          _createVNode(ClusterList, {
            clusters: __props.clusters,
            clusterColors: __props.clusterColors,
            onSelect: _cache[2] || (_cache[2] = (clusterId) => addSelectedClusterId(clusterId)),
            onUnselect: _cache[3] || (_cache[3] = (clusterId) => deleteSelectedClusterId(clusterId))
          }, null, 8, ["clusters", "clusterColors"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})